<template>
  <div class="admin-shell">
    <aside class="sidebar">
      <div class="brand">
        <strong>包装盒商城</strong>
        <span>包装工厂管理</span>
      </div>
      <nav aria-label="管理后台导航">
        <RouterLink
          to="/"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >▦</span>
          <span>概览</span>
        </RouterLink>
        <RouterLink
          to="/products"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >▣</span>
          <span>商品录入</span>
        </RouterLink>
        <RouterLink
          to="/reviews"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >▧</span>
          <span>客户评价</span>
        </RouterLink>
        <RouterLink
          to="/inventory"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >⌂</span>
          <span>库存管理</span>
        </RouterLink>
        <RouterLink
          to="/orders"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >◫</span>
          <span>订单管理</span>
        </RouterLink>
        <RouterLink
          to="/refunds"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >↩</span>
          <span>退款申请</span>
        </RouterLink>
        <RouterLink
          to="/customizations"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >▱</span>
          <span>定制咨询</span>
        </RouterLink>
        <RouterLink
          to="/custom-option-presets"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >◈</span>
          <span>常用定制参数</span>
        </RouterLink>
        <RouterLink
          to="/points-products"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >✦</span>
          <span>积分商品</span>
        </RouterLink>
        <RouterLink
          to="/points-redemptions"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >▤</span>
          <span>积分兑换订单</span>
        </RouterLink>
        <RouterLink
          to="/coupons"
          class="sidebar-link"
        >
          <span
            class="sidebar-link__icon"
            aria-hidden="true"
          >券</span>
          <span>优惠券管理</span>
        </RouterLink>
      </nav>
    </aside>
    <div class="admin-main">
      <header class="topbar">
        <div class="topbar__context">
          包装盒商城管理后台
        </div>
        <div
          class="topbar__search"
          role="search"
        >
          <span
            class="topbar__search-icon"
            aria-hidden="true"
          >⌕</span>
          <span>搜索订单号、产品或客户名称…</span>
        </div>
        <div
          class="topbar__actions"
          aria-hidden="true"
        >
          <span>♧</span>
          <span>⚙</span>
          <span>?</span>
        </div>
      </header>
      <main class="content">
        <RouterView />
      </main>
    </div>
  </div>
</template>
